import React, { useEffect, useState } from "react";
import "./Addcandidate.css";
import { ReactComponent as Uploadicon } from "./assets/upload.svg";
import { ReactComponent as UploadDiableicon } from "./assets/upload-disable.svg";
import { ReactComponent as Pdficon } from "./assets/pdficon.svg";
import { ReactComponent as Wordicon } from "./assets/wordicon.svg";
import { ReactComponent as Uploaddelete } from "./assets/uploaddelete.svg";
import LinearProgress, {
  LinearProgressProps,
} from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import PreviewEditModal from "./Previeweditmodal";
import { getDocument, GlobalWorkerOptions } from "pdfjs-dist";
import * as pdfjs from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.min";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import { referral_window_open } from './utils/constatnts';
GlobalWorkerOptions.workerSrc = pdfjs.GlobalWorkerOptions.workerSrc;

export default function Addcandidate(props: any) {
  const [selectedFile, setSelectedFile] = useState<File | any>(null);
  const [uploadProgress, setUploadProgress] = useState<any | null>(null);
  const [error, setError] = useState<any | null>(null);
  const allowedFileTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const [isEditDialogOpen, setisEditDialogOpen] = useState(false);
  const [isFile, setisFile] = useState<any>();
  const [Email, setEmail] = useState<any>("");
  const [MobileNumber, setMobileNumber] = useState<any>("");
  // const [rows, setRows] = React.useState([]);
  function LinearProgressWithLabel(
    props: LinearProgressProps & { value: number }
  ) {
    return (
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Box sx={{ width: "50%", mr: 1 }}>
          <LinearProgress variant="determinate" {...props} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">{`${Math.round(
            props.value
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }
  const handleCloseDialog = () => {
    setisEditDialogOpen(false);
    handleReset(); // Reset uploaded file and progress bar
  };
  
  const readFile = async (file: any) => {
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const arrayBuffer: any = reader.result;
        if (
          file.type === "application/msword" ||
          file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        ) {
          const zip = new PizZip(arrayBuffer);
          const doc = new Docxtemplater().loadZip(zip);
          const Extractdata = doc.getFullText();
          const modifiedData = Extractdata.replace(/\.com/g, '.com ');
          const emailRegex =/\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
          const emails = modifiedData.match(emailRegex);
          const mobileRegex = /\b(?:\+91)?[-\s()]*([1-9])\d{9}\b/g;
          const mobileNumbers = modifiedData.match(mobileRegex)?.map((number:any) => number.replace(/[,\s+()-]/g, ''));          
          setEmail(emails);
          setMobileNumber(mobileNumbers);
        } else if (file.type === "application/pdf") {
          const uint8Array = new Uint8Array(arrayBuffer);
          const binaryString = uint8Array.reduce((data, byte) => {
            return data + String.fromCharCode(byte);
          }, "");
          const doc = await getDocument({ data: binaryString }).promise;
          const page = await doc.getPage(1);
          const content = await page.getTextContent();
          const extractedItems = content.items
            .map((item: any) => item.str)
            .join(" ");
          const emailRegex =
          /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g;
          const emails = extractedItems.match(emailRegex);
          const mobileRegex = /\b(?:\+91)?[-\s()]*([1-9])\d{9}\b/g;
          const mobileNumbers = (extractedItems.match(mobileRegex) || []).map((number:any) => number.replace(/[,\s+()-]/g, ''));
          
          setEmail(emails);
          setMobileNumber(mobileNumbers);
        }
      } catch (error) {
        console.error("Error reading content:", error);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputElement = e.currentTarget;

    if (inputElement && inputElement.files && inputElement.files[0]) {
      const file = inputElement.files[0];

       if (!allowedFileTypes.includes(file.type)) {
         setError(
           "Unsupported file format. Please select a PDF, DOC, or DOCX file."
         );
       } else if (file.size > 2097152) {
         setError("Please upload a file smaller than 2 MB.");
       } else {
         setSelectedFile(file);
         readFile(file)
         handleFileUpload(file);
         setError(null);
       }
    }
  };

  const handleFileUpload = async (file: File) => {
    if (file) {
      let progress = 0;
      const formData = new FormData();
      formData.append("file", file);
      // try {
      //   let baseUrl = process.env.REACT_APP_API_URL;
      //   await axios.post(`${baseUrl}/fileupload/upload`, formData, {
      //     headers: {
      //       'Content-Type': 'multipart/form-data',
      //     },
      //   });
      setUploadProgress(progress);
      setUploadProgress(progress);
      const interval = setInterval(() => {
        progress = Math.min(progress + 10, 100);
        setUploadProgress(progress);

        if (progress === 100) {
          clearInterval(interval);
        }
      }, 100);
      // } catch (error) {
      //   console.error('Error uploading file:', error);
      // }
      setisFile(file);
    }
  };

  

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    if(referral_window_open){
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        const file: File = files[0];
        const passevent: any = {
          currentTarget: {
            files: [file],
          },
        };
        handleFileSelect(passevent);
      }
    }
  };
  const handleReset = () => {
    setisFile(null);
    setSelectedFile(null);
    setError(null);
    const fileInput = document.getElementById(
      "file-upload"
    ) as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }
  };
  const handleFileDelete = () => {
    setSelectedFile(null);
    setUploadProgress(null);
    setisFile(null);
    handleReset()
  };
  useEffect(() => {
    setUploadProgress(null);
  }, [selectedFile]);
  const handleEditItemClick = () => {
    setisEditDialogOpen(!isEditDialogOpen);
  };

  return (
    <div >
      <div className="upload-content-section">
          <div className="upload-info-title">
            <span style={{position:"relative", bottom:"8px"}}>Instructions to Refer Candidates</span>
          </div>
          <div className="upload-info-section">
            <ul style={{paddingLeft:"1.8em"}}>
                      <li>After Uploading Resume please click on Preview & Edit Button.</li>
                      <li>Please fill in all the mandatory fields as mentioned in the Preview & Edit Window.</li>
                      <li>Email ID & Mobile Number field – These fields are auto fetch, kindly verify before submitting.</li>
                      <li>Position/Job ID Field – Please refer the Open Position sheet to refer against the appropriate Position/Job ID.</li>
                      <li>Click Submit Button.</li>
                      {/* <li>Kindly choose the appropriate business unit and open position id.</li>
                      <li>Referral Bonus will be given as per standard policy and conditions</li> */}
              </ul>
          </div>
        </div>
      <div className="upload-container">
        <div
          className="upload-section"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          { referral_window_open ? 
              <Uploadicon style={{ paddingTop: "1em" }} /> : 
              <UploadDiableicon style={{ paddingTop: "1em" }} />
          }
          <div className={referral_window_open ? "content-section" : "disabled-content-section"}>
            <h3 style={{ margin: "0.5em" }}>Drag and drop your resume here</h3>
            <div className={referral_window_open ? "support-text" : ""}>
              (Supported Formats: Doc, Docx, Pdf)
            </div>
            <div style={{ margin: "1em 0" }}>
              <div style={{ margin: "0.5em 0" }}>Or</div>
              <div className="file-upload">
                <label htmlFor="file-upload" className={referral_window_open ? "file-upload-btn" : "file-upload-btn-disabled"}>
                  Upload Resume
                </label>
                <input id="file-upload" type="file" onChange={handleFileSelect} disabled={!referral_window_open}/>
              </div>

              {error && (
                <Typography variant="subtitle2" color="error">
                  {error}
                </Typography>
              )}
              <div className={referral_window_open ? "support-text" : ""} style={{ marginBottom: "2em" }}>
                (Maximum Size : 2 MB)
              </div>
            </div>
          </div>
        </div>
        {selectedFile && (
          <div className="progress-section">
            <div className="progress-icon">
              {selectedFile.type === "application/pdf" ? <Pdficon /> : <Wordicon />}
              
            </div>
            <div className="progress-bar">
              <span>
                {selectedFile.name}
                <span style={{ color: "#989494", paddingLeft: "1em" }}>
                  {(selectedFile.size / 1048576).toFixed(2) + " MB"}
                </span>
              </span>
              {uploadProgress !== null && (
                <LinearProgressWithLabel color="success" value={uploadProgress} style={{width:"100%"}}/>
              )}
            </div>
            <div className="progress-delete">
                <Uploaddelete onClick={handleFileDelete} />
              </div>
          </div>
        )}
        { referral_window_open &&
          <div className="preview-section">
            <Button
            
              variant="contained"
              sx={{
                textTransform: "capitalize",
                width: "180px",
                marginBottom: "0.5em",
                fontSize: "16px",
                fontWeight: "600",
              }}
              disabled={!isFile}
              onClick={() => handleEditItemClick()}
            >
              Preview & Edit
            </Button>
          </div>
        }
        { referral_window_open &&
        <PreviewEditModal
          isEditDialogOpened={isEditDialogOpen}
          handleCloseDialog={handleCloseDialog}
          isFile={isFile}
          getCandidateList={props.getCandidateList}
          email ={props.email} referrer_name={props.referrer_name}
          userRole = {props.userRole}
          read_emails={Email}
          read_mobileNumber={MobileNumber}
          />
        }
      </div>
    </div>
  );
}
